/* ============================================================
   TTWN - OUTIL DE DESSIN (canvas)
   ------------------------------------------------------------
   Ce code etait ecrit DEUX FOIS, en clair, dans deux sections :
   sections/landing-homepage.liquid (la page d'accueil) et
   sections/draw-canvas.liquid (la page Draw). Soit environ 20 Ko
   de JavaScript renvoyes dans le HTML a chaque visite - un HTML
   n'etant jamais mis en cache par le navigateur, contrairement a
   un fichier d'asset.

   Il n'y a desormais qu'une seule copie, chargee en differe et
   mise en cache par le navigateur apres la premiere visite.

   >>> A SAVOIR DANS L'EDITEUR DE THEME : un fichier externe n'est
       pas rejoue quand l'editeur recharge une section. Si le
       dessin ne repond plus apres avoir deplace ou reajoute la
       section dans l'editeur, il suffit de recharger la page.
       En navigation normale, cela n'arrive jamais.

   API exposee en fin de fichier : window.PaintApp
   = { undo, redo, clearCanvas, exportCanvas }, utilisee par les
   boutons de la barre d'outils (attributs onclick).
   ============================================================ */

(function() {
    'use strict';

    const CANVAS_RESOLUTION = 2400;

    const state = {
        brushSize: 4,
        currentColor: '#000000',
        isDrawing: false,
        lastX: 0,
        lastY: 0,
        points: [],
        history: [],
        historyIndex: -1
    };

    let canvas, ctx, canvasWrapper;
    let displaySize = 0;

    function init() {
        canvas = document.getElementById('paintCanvas');
        if (!canvas) {
            console.error('Canvas not found');
            return;
        }
        
        ctx = canvas.getContext('2d', { willReadFrequently: true });
        canvasWrapper = document.getElementById('canvasWrapper');

        canvas.width = CANVAS_RESOLUTION;
        canvas.height = CANVAS_RESOLUTION;

        ctx.fillStyle = '#ffffff';
        ctx.fillRect(0, 0, canvas.width, canvas.height);
        ctx.lineCap = 'round';
        ctx.lineJoin = 'round';

        calculateCanvasSize();
        initColorPicker();
        attachEvents();
        saveState();

        window.addEventListener('resize', debounce(calculateCanvasSize, 100));
        window.addEventListener('orientationchange', () => setTimeout(calculateCanvasSize, 150));
        
    }

    /* ============================================
       CUSTOM COLOR PICKER
       ============================================ */
    function initColorPicker() {
        const trigger = document.getElementById('colorTrigger');
        const popup = document.getElementById('colorPickerPopup');
        const palette = document.getElementById('colorPalette');
        const palettePicker = document.getElementById('palettePicker');
        const hueSlider = document.getElementById('hueSlider');
        const hueThumb = document.getElementById('hueThumb');
        const hexInput = document.getElementById('hexInput');
        const swatchesContainer = document.getElementById('colorSwatches');

        // État du color picker
        let hue = 0;
        let saturation = 100;
        let lightness = 0;
        let isPickingPalette = false;
        let isPickingHue = false;
        opacity: 0.8;

        // Couleurs prédéfinies
        const swatches = [
            '#000000', '#ffffff', '#ff0000', '#ff6600', 
            '#ffcc00', '#33cc33', '#0099ff', '#6633ff',
            '#cc33cc', '#ff6699', '#996633', '#666666'
        ];

        // Créer les swatches
        swatches.forEach(color => {
            const swatch = document.createElement('div');
            swatch.className = 'color-swatch';
            swatch.style.backgroundColor = color;
            swatch.addEventListener('click', () => {
                setColorFromHex(color);
                updateAll();
            });
            swatchesContainer.appendChild(swatch);
        });

        // Mettre à jour le dégradé de la palette
        function updatePalette() {
            const hueColor = `hsl(${hue}, 100%, 50%)`;
            palette.style.background = `
                linear-gradient(to top, #000, transparent),
                linear-gradient(to right, #fff, ${hueColor})
            `;
        }

        // Convertir HSL vers HEX
        function hslToHex(h, s, l) {
            s /= 100;
            l /= 100;
            const a = s * Math.min(l, 1 - l);
            const f = n => {
                const k = (n + h / 30) % 12;
                const color = l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
                return Math.round(255 * color).toString(16).padStart(2, '0');
            };
            return `#${f(0)}${f(8)}${f(4)}`;
        }

        // Convertir HEX vers HSL
        function hexToHsl(hex) {
            let r = parseInt(hex.slice(1, 3), 16) / 255;
            let g = parseInt(hex.slice(3, 5), 16) / 255;
            let b = parseInt(hex.slice(5, 7), 16) / 255;

            const max = Math.max(r, g, b), min = Math.min(r, g, b);
            let h, s, l = (max + min) / 2;

            if (max === min) {
                h = s = 0;
            } else {
                const d = max - min;
                s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
                switch (max) {
                    case r: h = ((g - b) / d + (g < b ? 6 : 0)) / 6; break;
                    case g: h = ((b - r) / d + 2) / 6; break;
                    case b: h = ((r - g) / d + 4) / 6; break;
                }
                h *= 360;
            }
            return { h, s: s * 100, l: l * 100 };
        }

        // Calculer la couleur depuis la position dans la palette
        function getColorFromPalettePosition(x, y) {
            const rect = palette.getBoundingClientRect();
            const px = Math.max(0, Math.min(1, x / rect.width));
            const py = Math.max(0, Math.min(1, y / rect.height));
            
            saturation = px * 100;
            const value = 1 - py;
            lightness = (value * (100 - saturation / 2));
            
            return hslToHex(hue, saturation, lightness);
        }

        // Mettre à jour depuis un code HEX
        function setColorFromHex(hex) {
            if (!/^#[0-9A-Fa-f]{6}$/.test(hex)) return;
            const hsl = hexToHsl(hex);
            hue = hsl.h;
            saturation = hsl.s;
            lightness = hsl.l;
        }

        // Mettre à jour tous les éléments visuels
        function updateAll() {
            const hex = hslToHex(hue, saturation, lightness);
            state.currentColor = hex;
            trigger.style.backgroundColor = hex;
            hexInput.value = hex.toUpperCase();
            updatePalette();
            
            // Position du picker dans la palette
            const px = saturation / 100;
            const py = 1 - (lightness / (100 - saturation / 2));
            palettePicker.style.left = `${px * 100}%`;
            palettePicker.style.top = `${Math.max(0, Math.min(1, py)) * 100}%`;
            
            // Couleur du picker = couleur sélectionnée
            palettePicker.style.backgroundColor = hex;
            
            // Position du thumb hue
            hueThumb.style.left = `${(hue / 360) * 100}%`;
        }

        // Events palette
        function handlePaletteMove(e) {
            if (!isPickingPalette) return;
            e.preventDefault();
            const rect = palette.getBoundingClientRect();
            const clientX = e.touches ? e.touches[0].clientX : e.clientX;
            const clientY = e.touches ? e.touches[0].clientY : e.clientY;
            const x = clientX - rect.left;
            const y = clientY - rect.top;
            getColorFromPalettePosition(x, y);
            updateAll();
        }

        palette.addEventListener('mousedown', (e) => {
            isPickingPalette = true;
            handlePaletteMove(e);
        });
        palette.addEventListener('touchstart', (e) => {
            isPickingPalette = true;
            handlePaletteMove(e);
        }, { passive: false });

        document.addEventListener('mousemove', handlePaletteMove);
        document.addEventListener('touchmove', handlePaletteMove, { passive: false });
        document.addEventListener('mouseup', () => isPickingPalette = false);
        document.addEventListener('touchend', () => isPickingPalette = false);

        // Events hue slider
        function handleHueMove(e) {
            if (!isPickingHue) return;
            e.preventDefault();
            const rect = hueSlider.getBoundingClientRect();
            const clientX = e.touches ? e.touches[0].clientX : e.clientX;
            const x = clientX - rect.left;
            hue = Math.max(0, Math.min(360, (x / rect.width) * 360));
            updateAll();
        }

        hueSlider.addEventListener('mousedown', (e) => {
            isPickingHue = true;
            handleHueMove(e);
        });
        hueSlider.addEventListener('touchstart', (e) => {
            isPickingHue = true;
            handleHueMove(e);
        }, { passive: false });

        document.addEventListener('mousemove', handleHueMove);
        document.addEventListener('touchmove', handleHueMove, { passive: false });
        document.addEventListener('mouseup', () => isPickingHue = false);
        document.addEventListener('touchend', () => isPickingHue = false);

        // Event hex input
        hexInput.addEventListener('change', () => {
            let val = hexInput.value.trim();
            if (!val.startsWith('#')) val = '#' + val;
            if (/^#[0-9A-Fa-f]{6}$/.test(val)) {
                setColorFromHex(val);
                updateAll();
            }
        });

        // Toggle popup
        trigger.addEventListener('click', (e) => {
            e.stopPropagation();
            e.preventDefault();
            const isOpening = !popup.classList.contains('active');
            popup.classList.toggle('active');
            // Bloquer le dessin quand le picker est ouvert
            window.colorPickerOpen = popup.classList.contains('active');
        });

        // Fermer si clic ailleurs (desktop + mobile)
        function closePickerOnOutsideClick(e) {
            const target = e.target || (e.touches && e.touches[0] && document.elementFromPoint(e.touches[0].clientX, e.touches[0].clientY));
            if (popup.classList.contains('active') && !popup.contains(target) && target !== trigger) {
                e.stopPropagation();
                e.preventDefault();
                popup.classList.remove('active');
                window.colorPickerOpen = false;
                window.blockNextDraw = true;
                setTimeout(() => { window.blockNextDraw = false; }, 50);
            }
        }

        document.addEventListener('mousedown', closePickerOnOutsideClick, true);
        document.addEventListener('touchstart', closePickerOnOutsideClick, true);

        // Init
        window.colorPickerOpen = false;
        updateAll();
    }

    function debounce(func, wait) {
        let timeout;
        return function(...args) {
            clearTimeout(timeout);
            timeout = setTimeout(() => func.apply(this, args), wait);
        };
    }

    function calculateCanvasSize() {
        const viewportWidth = window.innerWidth;
        const viewportHeight = window.innerHeight;

        const headerHeight = 50;
        const footerHeight = 60;
        const toolbarHeight = document.querySelector('.paint-toolbar-section')?.offsetHeight || 80;
        const padding = 20;

        const availableHeight = viewportHeight - headerHeight - footerHeight - toolbarHeight - padding;
        const availableWidth = viewportWidth - 40;

        displaySize = Math.min(availableHeight, availableWidth, 400);
        displaySize = Math.max(displaySize, 150);

        canvas.style.width = displaySize + 'px';
        canvas.style.height = displaySize + 'px';
        canvasWrapper.style.width = displaySize + 'px';
        canvasWrapper.style.height = displaySize + 'px';
    }

    function attachEvents() {
        // Mouse events
        canvas.addEventListener('mousedown', startDrawing);
        canvas.addEventListener('mousemove', draw);
        canvas.addEventListener('mouseup', stopDrawing);
        canvas.addEventListener('mouseleave', stopDrawing);

        // Touch events
        canvas.addEventListener('touchstart', handleTouchStart, { passive: false });
        canvas.addEventListener('touchmove', handleTouchMove, { passive: false });
        canvas.addEventListener('touchend', handleTouchEnd, { passive: false });
        canvas.addEventListener('touchcancel', handleTouchEnd, { passive: false });

        // Buttons
        document.getElementById('undoBtn').addEventListener('click', undo);
        document.getElementById('redoBtn').addEventListener('click', redo);
        document.getElementById('clearBtn').addEventListener('click', clearCanvas);
        document.getElementById('saveBtn').addEventListener('click', () => exportCanvas('png'));

        // Stroke slider
        const strokeSlider = document.getElementById('strokeSlider');
        const initialThumbSize = (strokeSlider.value / strokeSlider.max) * 8;
        strokeSlider.style.setProperty('--thumb-size', initialThumbSize + 'px');

        state.brushSize = 5 + (parseInt(strokeSlider.value) / 40) * 15;
        
        strokeSlider.addEventListener('input', (e) => {
            // Mapper 1-40 vers 5-30
            const raw = parseInt(e.target.value);
            state.brushSize = 5 + (raw / 40) * 15;
            const thumbSize = (e.target.value / e.target.max) * 8;
            e.target.style.setProperty('--thumb-size', thumbSize + 'px');
        });

        // Keyboard
        document.addEventListener('keydown', handleKeyboard);
        canvas.addEventListener('contextmenu', (e) => e.preventDefault());
    }

    function handleKeyboard(e) {
        if (e.ctrlKey || e.metaKey) {
            switch(e.key.toLowerCase()) {
                case 'z': e.preventDefault(); undo(); break;
                case 'y': e.preventDefault(); redo(); break;
                case 's': e.preventDefault(); exportCanvas('png'); break;
            }
        }
    }

    function getCanvasPos(e) {
        const rect = canvas.getBoundingClientRect();
        const scaleX = canvas.width / rect.width;
        const scaleY = canvas.height / rect.height;
        return {
            x: (e.clientX - rect.left) * scaleX,
            y: (e.clientY - rect.top) * scaleY
        };
    }

    function getTouchPos(e) {
        const rect = canvas.getBoundingClientRect();
        const touch = e.touches[0] || e.changedTouches[0];
        const scaleX = canvas.width / rect.width;
        const scaleY = canvas.height / rect.height;
        return {
            x: (touch.clientX - rect.left) * scaleX,
            y: (touch.clientY - rect.top) * scaleY
        };
    }

    function getScaledBrushSize() {
        return state.brushSize * (canvas.width / displaySize);
    }

    function startDrawing(e) {
        // Ne pas dessiner si le color picker est ouvert ou vient de se fermer
        if (window.colorPickerOpen || window.blockNextDraw) return;
        
        const pos = getCanvasPos(e);
        state.isDrawing = true;
        state.points = [pos, pos];
        state.lastX = pos.x;
        state.lastY = pos.y;

        const brushSize = getScaledBrushSize();
        ctx.beginPath();
        ctx.arc(pos.x, pos.y, brushSize / 2, 0, Math.PI * 2);
        ctx.fillStyle = state.currentColor;
        ctx.fill();
    }

    function draw(e) {
        if (!state.isDrawing) return;

        const pos = getCanvasPos(e);
        state.points.push(pos);

        const brushSize = getScaledBrushSize();
        ctx.strokeStyle = state.currentColor;
        ctx.lineWidth = brushSize;

        if (state.points.length >= 3) {
            const l = state.points.length;
            const p0 = state.points[l - 3];
            const p1 = state.points[l - 2];
            const p2 = state.points[l - 1];

            const mid1X = (p0.x + p1.x) / 2;
            const mid1Y = (p0.y + p1.y) / 2;
            const mid2X = (p1.x + p2.x) / 2;
            const mid2Y = (p1.y + p2.y) / 2;

            ctx.beginPath();
            ctx.moveTo(mid1X, mid1Y);
            ctx.quadraticCurveTo(p1.x, p1.y, mid2X, mid2Y);
            ctx.stroke();
        }

        state.lastX = pos.x;
        state.lastY = pos.y;
    }

    function stopDrawing() {
        if (state.isDrawing) {
            if (state.points.length >= 2) {
                const brushSize = getScaledBrushSize();
                const l = state.points.length;
                const p1 = state.points[l - 2];
                const p2 = state.points[l - 1];
                
                ctx.beginPath();
                ctx.moveTo(p1.x, p1.y);
                ctx.lineTo(p2.x, p2.y);
                ctx.strokeStyle = state.currentColor;
                ctx.lineWidth = brushSize;
                ctx.stroke();
            }
            
            state.isDrawing = false;
            state.points = [];
            saveState();
        }
    }

    function handleTouchStart(e) {
        // Ne pas dessiner si le color picker est ouvert ou vient de se fermer
        if (window.colorPickerOpen || window.blockNextDraw) {
            e.preventDefault();
            return;
        }
        
        e.preventDefault();
        const pos = getTouchPos(e);
        state.isDrawing = true;
        state.points = [pos, pos];
        state.lastX = pos.x;
        state.lastY = pos.y;

        const brushSize = getScaledBrushSize();
        ctx.beginPath();
        ctx.arc(pos.x, pos.y, brushSize / 2, 0, Math.PI * 2);
        ctx.fillStyle = state.currentColor;
        ctx.fill();
    }

    function handleTouchMove(e) {
        if (!state.isDrawing) return;
        e.preventDefault();

        const pos = getTouchPos(e);
        state.points.push(pos);

        const brushSize = getScaledBrushSize();
        ctx.strokeStyle = state.currentColor;
        ctx.lineWidth = brushSize;

        if (state.points.length >= 3) {
            const l = state.points.length;
            const p0 = state.points[l - 3];
            const p1 = state.points[l - 2];
            const p2 = state.points[l - 1];

            const mid1X = (p0.x + p1.x) / 2;
            const mid1Y = (p0.y + p1.y) / 2;
            const mid2X = (p1.x + p2.x) / 2;
            const mid2Y = (p1.y + p2.y) / 2;

            ctx.beginPath();
            ctx.moveTo(mid1X, mid1Y);
            ctx.quadraticCurveTo(p1.x, p1.y, mid2X, mid2Y);
            ctx.stroke();
        }

        state.lastX = pos.x;
        state.lastY = pos.y;
    }

    function handleTouchEnd(e) {
        e.preventDefault();
        stopDrawing();
    }

    function saveState() {
        state.history = state.history.slice(0, state.historyIndex + 1);
        state.history.push(canvas.toDataURL('image/png'));
        state.historyIndex++;
        if (state.history.length > 30) {
            state.history.shift();
            state.historyIndex--;
        }
    }

    function loadState(dataUrl) {
        const img = new Image();
        img.onload = () => {
            ctx.clearRect(0, 0, canvas.width, canvas.height);
            ctx.drawImage(img, 0, 0);
        };
        img.src = dataUrl;
    }

    function undo() {
        if (state.historyIndex > 0) {
            state.historyIndex--;
            loadState(state.history[state.historyIndex]);
        }
    }

    function redo() {
        if (state.historyIndex < state.history.length - 1) {
            state.historyIndex++;
            loadState(state.history[state.historyIndex]);
        }
    }

    function clearCanvas() {
        ctx.fillStyle = '#ffffff';
        ctx.fillRect(0, 0, canvas.width, canvas.height);
        saveState();
    }

    function exportCanvas(format) {
        const link = document.createElement('a');
        link.download = 'my_masterpiece.png';
        
        const exportCanvas = document.createElement('canvas');
        const exportCtx = exportCanvas.getContext('2d');
        const exportSize = 2400;
        
        exportCanvas.width = exportSize;
        exportCanvas.height = exportSize;
        exportCtx.drawImage(canvas, 0, 0, exportSize, exportSize);
        
        if (navigator.share && /mobile|android|iphone/i.test(navigator.userAgent)) {
            exportCanvas.toBlob(function(blob) {
                const file = new File([blob], 'my_masterpiece.png', { type: 'image/png' });
                navigator.share({
                    files: [file],
                    title: 'My Masterpiece'
                }).catch(() => {
                    downloadFile(exportCanvas);
                });
            }, 'image/png', 1.0);
        } else {
            downloadFile(exportCanvas);
        }
    }

    function downloadFile(exportCanvas) {
        const link = document.createElement('a');
        link.download = 'my_masterpiece.png';
        link.href = exportCanvas.toDataURL('image/png', 1.0);
        link.click();
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }

    window.PaintApp = { undo, redo, clearCanvas, exportCanvas };
})();
